export default defineNuxtRouteMiddleware(({ meta }) => {
  const {
    requiredCompanyPermissions,
    requiredUserPermissions,
    mustBeCompanyAdmin,
  } = meta

  // 権限チェックが不要なページは制限なし
  if (
    !requiredCompanyPermissions &&
    !requiredUserPermissions &&
    !mustBeCompanyAdmin
  ) {
    return true
  }

  // 権限チェックが必要なページは権限チェックを行う
  const { permitted } = usePermissionCheck({
    requiredCompanyPermissions,
    requiredUserPermissions,
    mustBeCompanyAdmin,
  })

  if (!permitted.value) {
    return abortNavigation({
      statusCode: 403,
      message: 'このページを表示する権限がありません',
      fatal: true,
    })
  }

  return true
})
